
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppFinish from "./SaleEditMobileFinish.vue";
import AppProperties from "./SaleEditMobileProperties.vue";
import AppRows from "./SaleEditMobileRows.vue";
import AppSendModal from "./SaleSendModal.vue";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	methods: {
		saleSent(){
			this.state.onFinish();
		}
	},
	components: {
		AppProperties,
		AppRows,
		AppFinish,
		AppSendModal,
	}
});
